/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum BidType {
  Floor = 'floor',
  Prebid = 'prebid',
  Online = 'online',
  PostSale = 'post_sale'
}
